import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import { CLIENT_ISSUE_POPUP_ID } from 'Component/NewIssuePopup/NewIssuePopup.config';
import { showPopup } from 'Store/Popup/Popup.action';
import { OrderType } from 'Type/Order.type';

import MyAccountCustomerServicePush from './MyAccountCustomerServicePush.component';

/** @namespace PeggysagePwa/Component/MyAccountCustomerServicePush/Container/mapStateToProps */
export const mapStateToProps = () => ({});

/** @namespace PeggysagePwa/Component/MyAccountCustomerServicePush/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    showPopup: (popupId, payload) => dispatch(showPopup(popupId, payload))
});

/** @namespace PeggysagePwa/Component/MyAccountCustomerServicePush/Container */
export class MyAccountCustomerServicePushContainer extends PureComponent {
    static propTypes = {
        showPopup: PropTypes.func.isRequired,
        order: OrderType
    };

    static defaultProps = {
        order: {}
    };

    containerFunctions = {
        onTicketButtonClick: this.onTicketButtonClick.bind(this)
    };

    onTicketButtonClick() {
        const { order, showPopup } = this.props;

        showPopup(
            CLIENT_ISSUE_POPUP_ID,
            {
                title: __('Ma demande'),
                order
            }
        );
    }

    containerProps() {
        // isDisabled: this._getIsDisabled()
    }

    render() {
        return (
            <MyAccountCustomerServicePush
              { ...this.containerFunctions }
              { ...this.containerProps() }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MyAccountCustomerServicePushContainer);
